import { Stack, TextField, Typography } from "@mui/material";

import { ErrorTypography } from "components/ErrorTypography";
import { PhoneNumberField } from "components/PhoneNumberField";

interface ExternalInviteStep {
  firstName: string;
  lastName: string;
  companyName: string;
  phoneNumber: string;
}

interface Props {
  email: string;
  externalData: ExternalInviteStep;
  onExternalDataChange: (data: ExternalInviteStep) => void;
  externalValidationErrors: Partial<ExternalInviteStep>;
  onValidationErrorClear: (field: keyof ExternalInviteStep) => void;
  externalInviteError: string | null;
}

export function ExternalFormStep(props: Props) {
  const {
    email,
    externalData,
    onExternalDataChange,
    externalValidationErrors,
    onValidationErrorClear,
    externalInviteError,
  } = props;

  return (
    <Stack spacing={3} mt={1}>
      <Typography variant="body2" color="text.secondary">
        This supplier is not yet on Evotrux. Please provide their details to
        send them an invitation.
      </Typography>

      <TextField label="Email" type="email" value={email} disabled fullWidth />

      <TextField
        label="First Name"
        value={externalData.firstName}
        onChange={(e) => {
          onExternalDataChange({ ...externalData, firstName: e.target.value });
          if (externalValidationErrors.firstName) {
            onValidationErrorClear("firstName");
          }
        }}
        required
        fullWidth
        placeholder="John"
        error={!!externalValidationErrors.firstName}
        helperText={externalValidationErrors.firstName}
      />

      <TextField
        label="Last Name"
        value={externalData.lastName}
        onChange={(e) => {
          onExternalDataChange({ ...externalData, lastName: e.target.value });
          if (externalValidationErrors.lastName) {
            onValidationErrorClear("lastName");
          }
        }}
        required
        fullWidth
        placeholder="Doe"
        error={!!externalValidationErrors.lastName}
        helperText={externalValidationErrors.lastName}
      />

      <TextField
        label="Company Name"
        value={externalData.companyName}
        onChange={(e) => {
          onExternalDataChange({
            ...externalData,
            companyName: e.target.value,
          });
          if (externalValidationErrors.companyName) {
            onValidationErrorClear("companyName");
          }
        }}
        required
        fullWidth
        placeholder="Acme Logistics"
        error={!!externalValidationErrors.companyName}
        helperText={externalValidationErrors.companyName}
      />

      <PhoneNumberField
        label="Phone Number (Optional)"
        value={externalData.phoneNumber}
        onChange={(phoneNumber) => {
          onExternalDataChange({ ...externalData, phoneNumber });
          if (externalValidationErrors.phoneNumber) {
            onValidationErrorClear("phoneNumber");
          }
        }}
        error={!!externalValidationErrors.phoneNumber}
        helperText={externalValidationErrors.phoneNumber}
        fullWidth
      />

      <ErrorTypography error={externalInviteError} />
    </Stack>
  );
}
